import { render } from "./ModalConfigs.vue?vue&type=template&id=8b6296da&scoped=true"
import script from "./ModalConfigs.vue?vue&type=script&lang=js"
export * from "./ModalConfigs.vue?vue&type=script&lang=js"

import "./ModalConfigs.vue?vue&type=style&index=0&id=8b6296da&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8b6296da"]])

export default __exports__